import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { User } from "@template/types";

export type UsersStatus = "idle" | "loading" | "succeeded" | "failed";

export interface UsersState {
  users: User[];
  status: UsersStatus;
  error: string | null;
}

const initialState: UsersState = {
  users: [],
  status: "idle",
  error: null,
};

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    usersRequestStarted(state) {
      state.status = "loading";
      state.error = null;
    },
    usersLoaded(state, action: PayloadAction<User[]>) {
      state.users = action.payload;
      state.status = "succeeded";
    },
    usersRequestFailed(state, action: PayloadAction<string>) {
      state.status = "failed";
      state.error = action.payload;
    },
    userAdded(state, action: PayloadAction<User>) {
      state.users.unshift(action.payload);
    },
    userUpdated(state, action: PayloadAction<User>) {
      const index = state.users.findIndex((user) => user.id === action.payload.id);
      if (index !== -1) state.users[index] = action.payload;
    },
    userRemoved(state, action: PayloadAction<string>) {
      state.users = state.users.filter((user) => user.id !== action.payload);
    },
  },
});

export const {
  usersRequestStarted,
  usersLoaded,
  usersRequestFailed,
  userAdded,
  userUpdated,
  userRemoved,
} = usersSlice.actions;

export default usersSlice.reducer;
